/**
 * @generated SignedSource<<856d99fa6cb5748cd8b387d42256b517>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "biId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "boId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BusinessBeneficialOwnerCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateBeneficialOwnerTPayload",
        "kind": "LinkedField",
        "name": "createBeneficialOwnerT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BeneficialOwnerT",
            "kind": "LinkedField",
            "name": "beneficialOwnerT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BusinessBeneficialOwnerCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateBeneficialOwnerTPayload",
        "kind": "LinkedField",
        "name": "createBeneficialOwnerT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BeneficialOwnerT",
            "kind": "LinkedField",
            "name": "beneficialOwnerT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f25f5f9ad71b9de8a8d91a4a3c74ac7f",
    "id": null,
    "metadata": {},
    "name": "BusinessBeneficialOwnerCreateMutation",
    "operationKind": "mutation",
    "text": "mutation BusinessBeneficialOwnerCreateMutation(\n  $input: CreateBeneficialOwnerTInput!\n) {\n  createBeneficialOwnerT(input: $input) {\n    beneficialOwnerT {\n      biId\n      boId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "686a5d75faddf5d02bd7db29e97ea6a2";

module.exports = node;
